/**
 * @generated SignedSource<<de2b8692b3f0c529d234597d5619bc53>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesPollUnsubscribeTaskQuery$variables = {
  id: string;
};
export type salesChannelSwitchQueriesPollUnsubscribeTaskQuery$data = {
  readonly productSwitcherTask: {
    readonly extraData: {
      readonly paymentMethodSetupTaskID: number | null;
    };
    readonly id: string;
    readonly lastError: string;
    readonly state: number;
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesPollUnsubscribeTaskQuery = {
  response: salesChannelSwitchQueriesPollUnsubscribeTaskQuery$data;
  variables: salesChannelSwitchQueriesPollUnsubscribeTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductSwitcherTask",
    "kind": "LinkedField",
    "name": "productSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastError",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTaskExtraData",
        "kind": "LinkedField",
        "name": "extraData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentMethodSetupTaskID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesPollUnsubscribeTaskQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesPollUnsubscribeTaskQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c20ad6fedbe2c6983e517d4fe2f2055e",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesPollUnsubscribeTaskQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchQueriesPollUnsubscribeTaskQuery(\n  $id: ID!\n) {\n  productSwitcherTask(id: $id) {\n    id\n    taskID\n    state\n    lastError\n    extraData {\n      paymentMethodSetupTaskID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "640d12fe6eae888e215d1fc017e24a80";

export default node;
